import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=3222e288&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=3222e288&prod&lang=scss&scoped=true"
import style1 from "./Permissions.vue?vue&type=style&index=1&id=3222e288&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3222e288",
  null
  
)

export default component.exports